var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 371.37 446.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#25252d;}.cls-2{fill:#82c48c;}.cls-3{fill:#373635;}.cls-4{fill:#21201f;}.cls-4,.cls-8{opacity:0.5;}.cls-5,.cls-8{fill:#fff;}.cls-6{fill:#e1e4fe;}.cls-7{fill:#6dc77a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 107") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.48,245.5a4.5,4.5,0,0,1-3.07-7.79L162.12,152a4.5,4.5,0,1,1,6.15,6.57L76.55,244.28A4.5,4.5,0,0,1,73.48,245.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.64,126.43a4.5,4.5,0,0,1-3.07-7.79L294.29,33a4.5,4.5,0,1,1,6.14,6.57l-91.72,85.69A4.47,4.47,0,0,1,205.64,126.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 263.94,
    y: 36.25,
    width: 99.46,
    height: 360.85,
    rx: 24.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.5,
    y: 259.06,
    width: 99.46,
    height: 134.82,
    rx: 24.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.42,280.62V371c0,12.28-15.75,22.24-35.15,22.24H25.83V258.39H69.27C88.67,258.39,104.42,268.34,104.42,280.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M234.14,280.62V371a22.25,22.25,0,0,1-22.25,22.24H184.41V258.39h27.48A22.24,22.24,0,0,1,234.14,280.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M104,372.55v1.73a22.23,22.23,0,0,1-22.23,22.23h-55A22.24,22.24,0,0,1,4.5,374.28v-1.73c0,12.28,10,10.33,22.24,10.33h55C94,382.88,104,384.83,104,372.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.91,398.38H26.55A26.58,26.58,0,0,1,0,371.83V281.11a26.58,26.58,0,0,1,26.55-26.55H81.92a26.58,26.58,0,0,1,26.54,26.55v90.72A26.58,26.58,0,0,1,81.91,398.38ZM26.55,263.56A17.57,17.57,0,0,0,9,281.11v90.72a17.57,17.57,0,0,0,17.55,17.55H81.91a17.57,17.57,0,0,0,17.55-17.55V281.11a17.56,17.56,0,0,0-17.54-17.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 134.22,
    y: 141.17,
    width: 99.46,
    height: 255.93,
    rx: 24.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.64,401.59H156.27A26.58,26.58,0,0,1,129.72,375V163.22a26.58,26.58,0,0,1,26.55-26.55h55.37a26.58,26.58,0,0,1,26.55,26.55V375A26.58,26.58,0,0,1,211.64,401.59ZM156.27,145.67a17.57,17.57,0,0,0-17.55,17.55V375a17.57,17.57,0,0,0,17.55,17.55h55.37A17.57,17.57,0,0,0,229.19,375V163.22a17.57,17.57,0,0,0-17.55-17.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 54.23,
    cy: 257.44,
    r: 25.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.55,256.56a25.32,25.32,0,1,1-49.86-6.25,25.32,25.32,0,0,0,49.08,0A24.78,24.78,0,0,1,79.55,256.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.23,287.26a29.82,29.82,0,1,1,29.82-29.82A29.86,29.86,0,0,1,54.23,287.26Zm0-50.64a20.82,20.82,0,1,0,20.82,20.82A20.84,20.84,0,0,0,54.23,236.62Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 183.95,
    cy: 138.31,
    r: 25.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M233.69,375.29V377a22.24,22.24,0,0,1-22.24,22.23h-55A22.24,22.24,0,0,1,134.22,377v-1.74c0,12.29,10,10.33,22.25,10.33h55C223.73,385.62,233.69,387.58,233.69,375.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M363.41,324.59h0a80.88,80.88,0,0,1-99.47,0h0c-5.46,13.26,0,44.55,0,15.48v4.1c0,29.06,6,52.62,18.25,52.62h63c12.28,0,18.24-23.56,18.24-52.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M209.14,136.61a25.32,25.32,0,1,1-49.86-6.25,25.32,25.32,0,0,0,49.08,0A25.24,25.24,0,0,1,209.14,136.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184,168.13a29.82,29.82,0,1,1,29.82-29.82A29.86,29.86,0,0,1,184,168.13Zm0-50.64a20.82,20.82,0,1,0,20.82,20.82A20.84,20.84,0,0,0,184,117.49Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 137.15,
    y: 437.7,
    width: 92.82,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.69,
    y: 437.7,
    width: 11,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.44,
    y: 437.7,
    width: 12.69,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 342.02,
    y: 69.17,
    width: 7,
    height: 60.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 341.85,
    y: 138.69,
    width: 7,
    height: 18.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.36,401.59H286A26.58,26.58,0,0,1,259.44,375V58.3A26.58,26.58,0,0,1,286,31.75h55.37A26.58,26.58,0,0,1,367.91,58.3V375A26.58,26.58,0,0,1,341.36,401.59ZM286,40.75A17.57,17.57,0,0,0,268.44,58.3V375A17.57,17.57,0,0,0,286,392.59h55.37A17.57,17.57,0,0,0,358.91,375V58.3a17.57,17.57,0,0,0-17.55-17.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 315.99,
    cy: 54.17,
    r: 27.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 210.36,
    y: 205.6,
    width: 7,
    height: 55.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 210.19,
    y: 272.12,
    width: 7,
    height: 11.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.91,
    y: 182.88,
    width: 12.46,
    height: 12.46,
    transform: "translate(554.25 -176.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.91,
    y: 207.8,
    width: 12.46,
    height: 12.46,
    transform: "translate(579.17 -151.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.91,
    y: 232.73,
    width: 12.46,
    height: 12.46,
    transform: "translate(604.1 -126.18) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 358.91,
    y: 257.66,
    width: 12.46,
    height: 12.46,
    transform: "translate(629.03 -101.25) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 113.66,
    y: 190.24,
    width: 12.46,
    height: 12.46,
    transform: "translate(341.85 257.34) rotate(136.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 95.51,
    y: 207.32,
    width: 12.46,
    height: 12.46,
    transform: "translate(322.2 299.31) rotate(136.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 77.36,
    y: 224.41,
    width: 12.46,
    height: 12.46,
    transform: "translate(302.55 341.28) rotate(136.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 316.99,
    cy: 32.71,
    r: 27.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M342,31.37a27.63,27.63,0,1,1-55.25,0,27.35,27.35,0,0,1,.85-6.82,27.63,27.63,0,0,0,53.55,0A27.35,27.35,0,0,1,342,31.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.31,64.25a32.13,32.13,0,1,1,32.13-32.13A32.16,32.16,0,0,1,315.31,64.25Zm0-55.25a23.13,23.13,0,1,0,23.13,23.12A23.14,23.14,0,0,0,315.31,9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.b01aff7cc9ed75186329f2498c80a100.svg";
export { ForwardRef as ReactComponent };